import { render } from "./CombinacaoVeiculo.vue?vue&type=template&id=bb3f5eec"
import script from "./CombinacaoVeiculo.vue?vue&type=script&lang=ts"
export * from "./CombinacaoVeiculo.vue?vue&type=script&lang=ts"
script.render = render

export default script